/**
 * Route for `salesforce-conversion-sync`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SalesforceConversionSyncPage } from "../features/salesforce-conversion-sync/SalesforceConversionSyncPage";

export const salesforceConversionSyncRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/salesforce-conversion-sync",
	component: SalesforceConversionSyncPage,
});

export default salesforceConversionSyncRoute;
